import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSelect } from '../../../web/src/components/form/language-select.jsx';
import { localeFromSegment } from '../../../shared-site-web/locales.js';

/**
 * Switches between the language paths, staying on the same page. Uses the
 * shared native <select> LanguageSelect so tapping on touch opens the OS
 * picker instead of a text input. The URL segment is lowercase (/en-us).
 * @returns {JSX.Element}
 */
export function LanguageToggle() {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();
	// en-us must be matched before en so the \b boundary doesn't stop early.
	const currentUrl = pathname.match(/^\/(en-us|en|ja|ko|zh-cn|zh-tw)\b/)?.[1] ?? 'en';
	const current = localeFromSegment(currentUrl);

	/**
	 * @param {string} lang — canonical locale code from the select value
	 * @returns {string}
	 */
	function altPath(lang) {
		const url = lang.toLowerCase();
		if (pathname === '/' || pathname === '') { return `/${url}`; }
		return pathname.replace(/^\/(en-us|en|ja|ko|zh-cn|zh-tw)\b/, `/${url}`);
	}

	return (
		<LanguageSelect
			value={current}
			onChange={(lang) => navigate(altPath(lang))}
			ariaLabel={t('site.nav.language')}
		/>
	);
}
